import React from "react";
import { ModalAllder } from "layouts/ModalAllder";
import { BusinessSettings } from "pages/customer/business-settings/BusinessSettings";

export function BusinessModal({
  modal = {
    mode: "normal",
    open: false,
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    pin: false,
  },
  setModal,
  onSuccess,
  businessGroupId,
}) {
  return (
    <ModalAllder
      modal={modal}
      setModal={setModal}
      htitle={"ข้อมูลธุรกิจ"}
      hbtn={true}
      bodypadding={false}
    >
      <BusinessSettings
        onModalClose={setModal}
        onSuccess={onSuccess}
        businessGroupId={businessGroupId}
      />
    </ModalAllder>
  );
}
